import { HasSocketEvent, Model } from "@models";
import { SocketEvent } from "@helpers/types";
import { NotificationTargets } from "@modules/notifications/domain/entities/notifications.model";

export class NotificationSocketEvent extends Model implements HasSocketEvent {
	created_at: string;
	is_read: boolean;
	is_seen: boolean;
	pid: string;
	read_at: string;
	seen_at: string;
	icon: iconEvent;
	unseen_count: number;
	event: NotificationEvent;
	skip_global_notification: boolean;

	eventData: SocketEvent;

	getEvent(): string {
		return this.eventData;
	}
}

interface NotificationEvent {
	name: string;
	title: string;
	subtitle?: string;
	target_path?: NotificationTargets | string;
	showAction?: boolean;
	actionMessage?: string;
}

interface iconEvent {
	color: string;
	color_dark: string;
	icon: string;
	icon_name: string;
	name: string;
	state: string;
}
